import { makeStyles } from "@material-ui/core/styles";
import CustomInputComponent from "../CustomInputComponent/CustomInputComponent";
import { FormattedMessage } from "react-intl";
import GlobalMessage from "messages/messages";
import SingleSelectComponent from "components/SingleSelectComponent/SingleSelectComponent";

const useStyles = makeStyles(theme => ({
  header: {
    width: "100%",
    height: "60px",
    display: "flex",
    justifyContent: "space-between",
    minWidth: "300px",
  },

  searchBar: {
    flex: "1",
    padding: "10px",
    width: "100%",
    minWidth: "100px",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  filterButtons: {
    flex: "1",
    padding: "10px",
    width: "100%",
    minWidth: "200px",
  },
}));

export function MessageHeader({
  filter,
  onFilterChange,
  status,
  onStatusChange,
  options,
}) {
  const classes = useStyles();

  return (
    <div className={classes.header}>
      <div className={classes.searchBar} data-cy="messageSearch">
        <CustomInputComponent
          label={<FormattedMessage {...GlobalMessage.search_messages} />}
          value={filter}
          onChange={e => {
            onFilterChange(e.target.value);
          }}
          fullWidth
        />
      </div>
      <div className={classes.filterButtons}>
        <SingleSelectComponent
          options={options}
          labelProperty="label"
          value={options.find(o => o.value === status)}
          onChange={option => {
            onStatusChange(option.value);
          }}
        />
      </div>
    </div>
  );
}
